/** Mirrors BE `CLASS_UPDATE_ERROR_CODES` for partial-success class updates. */
export const CLASS_UPDATE_ERROR_CODES = {
  CALENDAR_RECONNECT_FAILED: 'CLASS_SAVED_CALENDAR_RECONNECT_FAILED',
  CALENDAR_SYNC_FAILED: 'CLASS_SAVED_CALENDAR_SYNC_FAILED',
} as const;

export type ClassUpdateErrorCode =
  (typeof CLASS_UPDATE_ERROR_CODES)[keyof typeof CLASS_UPDATE_ERROR_CODES];

const CLASS_SAVED_ERROR_CODES = new Set<string>(
  Object.values(CLASS_UPDATE_ERROR_CODES),
);

export const isClassSavedCalendarErrorCode = (
  code: unknown,
): code is ClassUpdateErrorCode =>
  typeof code === 'string' && CLASS_SAVED_ERROR_CODES.has(code);

export type ClassUpdateApiErrorPayload = {
  message?: unknown;
  code?: unknown;
};

export const getClassUpdateApiError = (
  error: unknown,
): { message: string | null; code: ClassUpdateErrorCode | null } => {
  if (
    typeof error !== 'object' ||
    error === null ||
    !('response' in error) ||
    typeof (error as { response?: unknown }).response !== 'object' ||
    (error as { response?: unknown }).response === null
  ) {
    return { message: null, code: null };
  }

  const data = (
    error as { response: { data?: ClassUpdateApiErrorPayload } }
  ).response.data;

  const message =
    data && typeof data.message === 'string' ? data.message : null;
  const code = isClassSavedCalendarErrorCode(data?.code) ? data.code : null;

  return { message, code };
};
